module.exports = __webpack_public_path__ + "static/media/report-avatar.eeab412f.png";